module.exports = __webpack_public_path__ + "img/id.2f4e1f25.svg";